import { render, staticRenderFns } from "./MagnifyingGlass.vue?vue&type=template&id=0163f30a&scoped=true"
import script from "./MagnifyingGlass.vue?vue&type=script&lang=js"
export * from "./MagnifyingGlass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163f30a",
  null
  
)

export default component.exports